import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "submitButton",
    "usernameInput",
    "emailInput"
  ]

  validateUsername () {
    const length = this.usernameInputTarget.value.length

    this.submitButtonTarget.disabled = (length < 3) || (length > 16)
  }
}
